module.exports = __webpack_public_path__ + "img/img1.c0be6067.jpg";